import React from 'react';
import styled from 'styled-components';

import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import { LoadingIndicator } from 'components/LoadingIndicator';

const LoadingCellStyled = styled.td`
  background-color: ${(props) => props.theme.table.body.backgroundColor};
  padding: 50px !important;
`;

export const LoadingDataIndicator: React.FC<Table.NoDataCellProps> = ({
  colSpan,
  ...restProps
}: Table.NoDataCellProps) => (
  <LoadingCellStyled colSpan={colSpan} {...restProps}>
    <div className="dx-g-bs4-fixed-block">
      <LoadingIndicator />
    </div>
  </LoadingCellStyled>
);
